import React from "react";
import Grid from "../Grid/Grid";

function AddGroupModal({ visible, setVisible, setParameter }) {
  const handleAddGroupSubmit = (event) => {
    event.preventDefault();

    const group = event.target[0]?.value;
    const name = event.target[1]?.value;

    const newParameter = {
      category: group,
      categoryTitle: group,
      id: name,
      value: 0,
    };

    setParameter((prevItems) => [...prevItems, newParameter]);
    setVisible(false);

    const form = document.getElementById("addGroup");
    form.reset();
  };

  return (
    <form onSubmit={handleAddGroupSubmit} id="addGroup">
      <div
        className={`modal fade ${visible ? "show" : ""}`}
        id="addGroupModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={!visible}
        data-keyboard
        data-backdrop={visible}
        style={{ display: visible ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content search-modal">
            <Grid>
              <h3 className="text-dark modal-header col-12">
                Gruppe hinzufügen
              </h3>

              <div className="form-group col-12">
                <label className="text-dark" for="formName">
                  Gruppe
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="formName"
                    required
                  />
                </div>
              </div>

              <div className="form-group col-12">
                <label className="text-dark" for="formName">
                  Name
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="formName"
                    required
                  />
                </div>
              </div>
            </Grid>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-toggle="modal"
                data-target="#addGroup"
                onClick={() => setVisible(false)}
              >
                Abbrechen
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-search-custom dismiss-active-or-focus"
                data-toggle="modal"
                data-target="#addGroup"
                onClick={() => setVisible(false)}
              >
                Hinzufügen
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default AddGroupModal;
